import { CustomError } from 'ts-custom-error';

import { setClassName } from '@change-corgi/core/error';

export class PageDataError<CODE extends string> extends CustomError {
	readonly code: CODE;
	readonly requestId?: string;

	constructor(
		code: CODE,
		{
			message,
			...options
		}: {
			message?: string;
			cause?: unknown;
			requestId?: string;
		} = {},
	) {
		super(message || code, options);
		this.code = code;
		this.requestId = options.requestId;
	}
}
setClassName(PageDataError, 'PageDataError');
